import React, { useState } from 'react'
import Select from "react-select"
import { ToastContainer, toast } from 'react-toastify'
import { Navigate, useNavigate } from 'react-router-dom'
import '../Video/Addvideo.css'
import { AddKlApi } from '../../Services/allApi'
function AddKla() {
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        kla_no: null,
        constitution_date: "",
        dissolution_date: null,
        total_no_of_sessions: null,
        total_sittings: null,
        total_business_hours: null
    });
    

    const handleAddKla = async () => {
        var KlaApiResult
       if(formData?.kla_no&&formData?.constitution_date){

            var token = sessionStorage.getItem('access_token')
            const reqHeader = {
                "Content-Type": "application/json", "Authorization": `${token}`
            }
            console.log(token);
            try{
                KlaApiResult=await AddKlApi(formData,reqHeader)
                console.log(KlaApiResult);
                if(KlaApiResult.status==200){
                    toast.success("KLA added successfully")
                }
                else{
                    toast.error("Error while adding KLA")
                }
            }catch(err){
                console.log(err);
                toast.error("There was an error")
            }

        

        console.log(formData);}
        else{
            toast.warning("Please fill kla and start date")
        }
    }

    return (

        <div className='w-full h-full flex justify-center' style={{ fontFamily: 'ropa sans' }}>
            <div className='w-9/12  flex flex-col '>
                <div className='flex justify-center '><h2 className='mt-12 md:text-xl text-md'>Add New KLA</h2></div>

                {/* row 1 */}
                <div className='flex flex-row justify-between flex-wrap mt-16'>

                    {/* kla number */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="fname">KLA No</label>
                        <input value={formData.kla_no} onChange={(e) => setFormData({ ...formData, kla_no: e.target.value })} type="number" name="" id="fname" className='w-full h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/* total sessions */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="lname">Total Sessions</label>
                        <input value={formData.total_no_of_sessions} onChange={(e) => setFormData({ ...formData, total_no_of_sessions: e.target.value })} type="text" name="" id="lname" className='w-fll h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>



                </div>


                {/* row 2 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* Total sittings */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="constituency">Total Sittings</label>
                        <input value={formData.total_sittings} onChange={(e) => setFormData({ ...formData, total_sittings: e.target.value })} type="text" name="" id="constituency" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>


                    {/* Total business hours */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="constituency">Total Business Hours</label>
                        <input value={formData.total_business_hours} onChange={(e) => setFormData({ ...formData, total_business_hours: e.target.value })} type="text" name="" id="constituency" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>
                </div>

                {/* row 3 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/*start Date */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="date">Start Date</label>
                        <input value={formData.constitution_date} onChange={(e) => setFormData({ ...formData, constitution_date: e.target.value })} type="date" name="" id="sdate" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/*End Date */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="endate">End Date</label>
                        <input value={formData.dissolution_date} onChange={(e) => setFormData({ ...formData, dissolution_date: e.target.value })} type="date" name="" id="endate" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>



                </div>

                {/* Action buttons */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* dummy div for filling left space */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                    </div>

                    <div className='mt-6 flex flex-row md:justify-end justify-center md:w-5/12 w-full'>
                        <div className='flex justify-evenly flex-row mt-7'>
                            <button className='h-10 bg-primary w-28 text-white rounded-lg' onClick={handleAddKla}>Save</button>
                            <button className='ms-10 h-10 bg-white w-28 text-primary rounded-lg border-2 hover:bg-blue-200' >Cancel</button>
                        </div>
                    </div>
                </div>

            </div>

            <ToastContainer
                style={{ width: '400px', /* other styles */ }}
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>


    )
}

export default AddKla